<template>
  <div class="p_supply_module p_history_box">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">施工队编号</div>
                    <el-input v-model="listQuery.strConstrteamCode" size="small" clearable></el-input>
                    <!-- <el-select v-model="listQuery.strConstrteamCode" placeholder="" size="small" filterable>
                        <el-option v-for="(item,i) in teamList" :key="i+'d'" :label="item.StrConstrteamCode" :value="item.StrConstrteamCode"></el-option>
                    </el-select> -->
                </div>
                <div class="screenInput">
                    <div class="flname">是否发送</div>
                    <el-select v-model="listQuery.strIsSend" size="small" clearable placeholder="">
                        <el-option label="已发送" value="1"></el-option>
                        <el-option label="未发送" value="0"></el-option>
                    </el-select>
                </div>
                <div class="screenInput">
                    <div class="flname">是否确认</div>
                    <el-select v-model="listQuery.strIsComfirm" size="small" clearable placeholder="">
                        <el-option label="已确认" value="1"></el-option>
                        <el-option label="未确认" value="0"></el-option>
                    </el-select>
                </div>
                <!-- <div class="screenInput">
                  <div class="flname">实发月</div>
                  <el-date-picker size="small" value-format="yyyy-MM"
                        v-model="listQuery.StrActualDate"
                        type="month"
                        placeholder="">
                    </el-date-picker>
                </div> -->
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box">
        <!-- <SupComTabs ref="child" :active="activeName" @change="currChange($event)"></SupComTabs> -->
        <el-tabs v-model="activePageName" @tab-click="handleClick" class="s_tabs_box">
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_summary'],permissionLists)" label="结算核对汇总表" name="third"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_actual'],permissionLists)" label="实发报表" name="first"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_confirm'],permissionLists)" label="确认收款人数据" name="four"></el-tab-pane>
            <el-tab-pane v-if="checkPermission(['verifySummary_tab_history'],permissionLists)" label="历史记录" name="second"></el-tab-pane>
        </el-tabs>
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="r_act_item" v-if="!this.isNull(this.tableData)&&(checkPermission(['generatedRecords_dlt'],permissionLists))">
              <el-button size="small" type="success" @click="dltHandle">删除当前报表</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['generatedRecords_form'],permissionLists)">
              <el-button size="small" type="success" @click="produceHandle">生成报表</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['generatedRecords_send'],permissionLists)">
              <el-button :disabled="isSendFinish" size="small" type="success" @click="sendHandle">发送</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['generatedRecords_allsend'],permissionLists)">
              <el-button :disabled="isSendFinish" size="small" type="success" @click="allSendHandle">全部发送</el-button>
            </div>
            <div class="r_act_item" v-if="!this.isNull(this.tableData)&&(checkPermission(['generatedRecords_export'],permissionLists))">
              <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>
          </div>
        </div>
        <el-table ref="multipleTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" v-loading="tableLoading" @selection-change="handleSelectionChange" :max-height="tableHeight-100" :data="tableData" style="width:100%" border>
            <el-table-column type="selection" width="35"></el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" :key="index" :min-width="item.StrColumName.indexOf('+')>-1||item.StrColumName.indexOf('套餐')>-1||item.StrColumName.indexOf('负责人身份证')>-1 ? '210px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('电子邮箱')>-1||item.StrColumName.indexOf('时间')>-1?'150px':'110px'" align="center"
                :fixed="item.StrColumName=='实发月'||item.StrColumName=='施工队编号'">
                <template slot-scope="{row}">
                    <el-input v-if="item.StrColumName.indexOf('其他应付')>-1" v-model="row[item.StrColumId]" type="number" size="small" clearable :disabled="row.isEditInput"></el-input>
                    <span v-else-if="item.StrColumName.indexOf('本月应付')>-1">{{ Number(row.PriTotal)+Number(row.PriOthermeet)}}</span>
                    <el-input v-else-if="item.StrColumName=='备注'" v-model="row[item.StrColumId]" size="small" clearable :disabled="row.isEditInput"></el-input>
                    <span v-else-if="item.StrColumName.indexOf('是否发送')>-1">
                        {{row.StrIsSend=='1'?'已发送':'未发送'}}
                    </span>
                    <span v-else-if="item.StrColumName.indexOf('是否确认')>-1">
                        {{row.StrIsComfirm=='1'?'已确认':'未确认'}}
                    </span>
                    <span v-else>{{row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
            <el-table-column align="center" label="操作" fixed="right" width="140px" class-name="re_act_box">
              <template slot-scope="{row}">
                <el-button v-if="row.StrIsComfirm == '1'&&(checkPermission(['generatedRecords_dtl'],permissionLists))" type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
                <el-button v-if="row.isEditInput&&(row.StrIsComfirm!='1')&&(checkPermission(['generatedRecords_edit'],permissionLists))" type="info" size="mini" plain @click="editHandle(row)">编辑</el-button>
                <el-button v-if="!row.isEditInput&&(row.StrIsComfirm!='1')" type="info" size="mini" plain @click="saveEditHandle(row)">保存</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
    <!-- 生成报表弹框 -->
    <el-dialog title="设置自由组合" :visible.sync="produceVisible" width="900px" class="res_dialog">
        <div class="f_box">
            <div class="f_left">实发月:</div>
            <div class="f_right">
                <el-date-picker v-model="StrActualDate" value-format="yyyy-MM" size="small"
                    type="month">
                </el-date-picker>
            </div>
        </div>
        <div class="add_dialog_box">
            <div class="add_title_box">
                <div class="t_item">结算月</div>
                <div class="t_item">业务分类</div>
                <div class="t_item">金额分类</div>
                <div class="t_item">操作</div>
            </div>
        </div>
        <div v-for="(item, index) in reportList" :key="index" class="add_form_list">
            <div class="add_form_item">
                <el-date-picker v-model="item.StrSettleDate" value-format="yyyy-MM" size="small" class="s_input"
                    type="month">
                </el-date-picker>
                <el-select v-model="item.StrBusitype" placeholder="" size="small" class="s_input">
                    <el-option label="安装" value="安装"></el-option>
                    <el-option label="维修" value="维修"></el-option>
                    <el-option label="移桩" value="移桩"></el-option>
                </el-select>
                <el-select v-model="item.StrPricetype" placeholder="" size="small" class="s_input">
                    <el-option
                    v-for="(item, index) in priceList"
                    :key="index+'p'"
                    :label="item.Basname"
                    :value="item.Basname">
                    </el-option>
                    <!-- <el-option label="95%费用" value="95%费用"></el-option>
                    <el-option label="5%质保金" value="5%质保金"></el-option> -->
                </el-select>
                <div class="s_input">
                    <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle(reportList,index)"></i>
                    <i class="el-icon-circle-plus-outline dlt_icon" title="新增" @click="addReportHandle"></i>
                </div>
            </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="produceVisible = false"
            size="small"
            >取消</el-button>
          <el-button
            type="primary" class="com_dialog_btn"
            @click="saveProHandle" :disabled="isSaveHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹框 -->
    <el-dialog title="详情" :visible.sync="dtlVisible" width="900px" class="res_dialog">
        <div class="dtl_box" v-if="!isNull(strComRemark)">
            <p>备注</p>
            <div>{{strComRemark}}</div>
        </div>
        <el-table v-loading="payeeLoading" :highlight-current-row="false" class="re_table" :data="payeeData" style="width:100%">
            <el-table-column align="center" label="序号" min-width="60px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.r.Strorder}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="收款人姓名" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.StrPayeeName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="金额" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.r.PriCollect}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="收款人身份证" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.StrPayeeIdcard}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="收款银行卡号" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.StrPayeeBankNum}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="收款银行" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.StrPayeeBankName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="收款人电话" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.StrPayeeTel}}</span>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary" class="com_dialog_btn"
            @click="dtlVisible = false"
            size="small"
            >关闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        isSaveHandle:false,
        activePageName:'',
        teamList:[],//施工队列表
        basicQuery:{
            StrPerStatus:'constrCost'
        },
        priceList:[],
        teamQuery:{
          strConstrteamName:'',// 施工队名称
          strSerStatus:'',// 服务状态 正常/退出
          strExamStatus:'',// 通过/不通过
          strArea:'',//区域
          strCityCompany:'',//城市公司
          currpage:1,
          perpage:1000000
        },
        isEditInput:true,
        downVisible:false,
        btnLoading:false,
        custPath: '',//导出文件下载路径
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'实发报表',
        activeName:'six',
        tableData: [],
        dateRangeVal:[],
        // 生成报表参数
        produceQuery:{
            StrActualDate:'',//结算月
            StrSettleDate:'',//选择月份
            StrBusitype:'',//业务分类
            StrPricetype:''//金额分类
        },
        listQuery:{
            gdident:'',// 标识
            strConstrteamCode:'',// 施工队编号  H5页面结算单列表用
            strIsSend:'',//是否发送
            strIsComfirm:'',//是否确认
            currpage:1,
            perpage:10
        },
        // 表头参数
        titleQuery:{
          gdident:''
        },
        // 导出参数
        exportQuery:{},
        produceVisible:false,
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        // 自由组合列表
        reportList:[
            {
                StrSettleDate:'',//选择月份
                StrBusitype:'',//业务分类
                StrPricetype:''//金额分类
            }
        ],
        StrActualDate:'',
        multipleSelection: [],
        // 修改金额参数
        editPriceQuery:{
            gdCordid:'',
            PriOthermeet:'',//其他应收
            PriMonthmeet:'',//本月应收
            StrRemark:''//备注
        },
        //选中是发送数据
        selSendList:[],
        sendQuery:{
            gdCordids:'',
            strtype:'',// all 全部
            gdident:''//标识
        },
        dtlVisible:false,
        payeeData:[],
        payeeLoading:false,
        checkQuery:{
            StrSettleDate:'',// 选择月份
            StrBusitype:'',// 选择业务分类
            StrPricetype:''// 选择金额分类
        },
        hisQuery:{
            gdident:''
        },
        dtlQuery:{
            GdCordid:''
        },
        // 确认详情备注
        strComRemark:'',
        isSendFinish:false,
        // 按钮权限参数
        butQuery:{
          path:'/verifySummary',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
        this.calHeight();
        this.getButtonPower()
        this.getTeamList()
        this.getBasicList()
    },
    methods: {
        checkPermission,
        // 获取按钮权限
        getButtonPower(){
            let that = this
            let param = this.$route.query.active
            let gdident = that.$route.query.gdident
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
                if(!this.isNull(param)){
                    this.activePageName = param
                    if(!that.isNull(gdident)){
                        that.listQuery.gdident = gdident
                        that.titleQuery.gdident = gdident
                        that.getTableTitleLists()
                    }else{
                        // 获取历史列表
                        that.getHistoryList()
                    }
                }else{
                    if(that.checkPermission(['verifySummary_tab_actual'],that.permissionLists)){
                        that.activePageName = 'first'
                        if(!that.isNull(gdident)){
                            that.listQuery.gdident = gdident
                            that.titleQuery.gdident = gdident
                            that.getTableTitleLists()
                        }else{
                            // 获取历史列表
                            that.getHistoryList()
                        }
                    }
                }
              }else{
                this.permissionLists = []
                this.activePageName = ''
              }
            }else{
              this.permissionLists = []
              this.activePageName = ''
            }
          })
        },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 详情
        dtlHandle(row){
            this.dtlVisible = true
            this.dtlQuery.GdCordid = row.GdCordid
            this.getDtlData()
        },
        // 获取基础信息--金额分类
        getBasicList(){
            xz.getbaseBaList(this.basicQuery.StrPerStatus).then(res => {
                // console.log('金额分类', res)
                if (res.status == 'ok') {
                    this.priceList = res.msg
                } else {
                    this.priceList = []
                }
            })
        },
        // 删除当前报表
        dltHandle(){
            let that = this
            this.$confirm('此操作将删除当前报表, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                xz.delConstrCost({gdident:that.listQuery.gdident}).then(res => {
                    // console.log('删除',res)
                    if(res.status == 'ok'){
                        this.$message({ type: 'success', message: '操作成功' })
                        this.getList()
                    }else{
                        this.$message({ type: 'success', message: res.msg })
                    }
                }).catch(err=>{
                    console.log("err",err)
                })
            })
        },
        // 确认详情
        getDtlData(){
            xz.getCostRecordsdetail(this.dtlQuery).then(res => {
                if (res.status == 'ok') {
                    this.payeeData = res.msgcom
                    this.strComRemark = res.msg[0].StrComRemark
                }else{
                    this.payeeData = []
                    this.strComRemark = ''
                }
                // console.log('表头', res)
            })
        },
        // 发送
        sendHandle(){
            this.sendQuery.strtype = ''
            this.sendQuery.gdCordids = this.selSendList.toString()
            if(this.isNull(this.sendQuery.gdCordids)){
                this.$message({ type: 'warning', message: '请选择要发送的数据' })
                return
            }
            this.$confirm('此操作将发送该数据，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.comSendRequest()
            })
        },
        // 全部发送
        allSendHandle(){
            this.sendQuery.strtype = 'all'
            this.sendQuery.gdCordids = ''
            this.$confirm('此操作将发送该数据，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.comSendRequest()
            })
        },
        comSendRequest(){
            this.isSendFinish = true
            xz.sendReportRecordsinf(this.sendQuery).then(res => {
                if (res.status == 'ok') {
                    this.$message({ type: 'success', message: '操作成功' })
                    this.getList()
                }else{
                    this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
                this.isSendFinish = false
                // console.log('表头', res)
            })
        },
        handleSelectionChange(val) {
            this.selSendList = []
            this.multipleSelection = val;
            // console.log('ff',val)
            if(!this.isNull(val)){
                for (let i = 0; i < val.length; i++) {
                    let element = val[i];
                    this.selSendList.push(element.GdCordid)
                }
                this.sendQuery.gdident = val[0].GdCordid
            }
        },
        // 获取施工队列表
        getTeamList(){
            xz.getConstrTeamLists(this.teamQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.teamList = res.msg
                }else{
                  this.teamList = []
                }
            })
        },
        // 获取默认表头(无数据)
        getDefaultTitleLists(){
            let titleQuery = {
                strTableId:'JB_report_ConstrCost_Records', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
                strIsFixed:''
            }
          xz.getEcustColumnList(titleQuery.strTableId,titleQuery.strIsFixed).then(res => {
            // console.log('33',res)
            if (res.status == 'ok') {
              this.tableTitle = res.msg
            }else{
              this.tableTitle = []
            }
          })
        },
        // 获取历史列表
        getHistoryList(){
            let hQuery = {
                startDate:'',// 开始时间
                endDate:'',// 结束时间
                StrActualDate:'',// 实发月选择
                currpage:1,
                perpage:10
            }
            xz.getConstrCostLists(hQuery).then(res => {
                if (res.status == 'ok') {
                    if(!this.isNull(res.msg)){
                        this.hisQuery.gdident = res.msg[0].Gdident
                        this.listQuery.gdident = res.msg[0].Gdident
                        this.titleQuery.gdident = res.msg[0].Gdident
                        // 表头
                        this.getTableTitleLists()
                    }else{
                        this.getDefaultTitleLists()
                    }
                }
                // console.log('表头', res)
            })
        },
        // 保存
        saveEditHandle(row){
            this.editPriceQuery = {
                gdCordid:row.GdCordid,
                PriOthermeet:row.PriOthermeet,//其他应收
                PriMonthmeet:Number(row.PriTotal)+Number(row.PriOthermeet),//本月应收
                StrRemark:row.StrRemark//备注
            }
            if(this.isNullNotZero(row.PriOthermeet)){
                this.$message({ type: 'warning', message: '请输入其他应付' })
                return false
            }
            xz.saveReportRecordsinf(this.editPriceQuery).then(res => {
                if (res.status == 'ok') {
                    this.$message({ type: 'success', message: '操作成功' })
                    this.getList()
                }else{
                    this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
            })
        },
        // 编辑
        editHandle(row){
          // console.log('11',row)
            row.isEditInput = false
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.outputReportList('JB_report_ConstrCost_Records',this.exportQuery).then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        handleClick(tab){
            // console.log('tab',tab)
            if(tab.name == 'second'){
                this.$router.push({
                    path: '/historyReport',
                    query: {
                        active: 'second'
                    }
                })
            }
            if(tab.name == 'third'){
                this.$router.push({
                    path: '/verifySummary',
                    query: {
                        active: 'third'
                    }
                })
            }
            if(tab.name == 'four'){
                this.$router.push({
                    path: '/receiptConfirmation',
                    query: {
                        active: 'four'
                    }
                })
            }
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 新增组合
        addReportHandle(){
            let that = this
            if(this.reportList.length>9){
                this.$message({ type: 'warning', message: '自由组合形式最多10种' })
                return false
            }
            if(that.reportList.some(val => this.isNull(val.StrSettleDate))){
                this.$message({ type: 'warning', message: '请选择月份' })
                return false
            }
            if(that.reportList.some(val => this.isNull(val.StrBusitype))){
                this.$message({ type: 'warning', message: '请选择业务分类' })
                return false
            }
            if(that.reportList.some(val => this.isNull(val.StrPricetype))){
                this.$message({ type: 'warning', message: '请选择金额分类' })
                return false
            }
            let eleLength = that.reportList.length
            this.checkQuery = {
                StrSettleDate:that.reportList[eleLength-1].StrSettleDate,// 选择月份
                StrBusitype:that.reportList[eleLength-1].StrBusitype,// 选择业务分类
                StrPricetype:that.reportList[eleLength-1].StrPricetype// 选择金额分类
            }
            // 实发报表-判定组合是否已经使用
            xz.getIsUsedcloumname(this.checkQuery).then(res => {
                if (res.status != 'ok') {
                    // console.log('rr',res)
                    this.$message({ type: 'error', message: res.msg })
                    // that.reportList[eleLength-1].StrSettleDate = ''
                    return false
                }else{
                    this.reportList.push({
                        StrSettleDate:'',//选择月份
                        StrBusitype:'',//业务分类
                        StrPricetype:''//金额分类
                    });
                }
            })
        },
        // 删除
        dltSpendHandle(data,index){
            if(data.length > 1){
                data.splice(index, 1)
            }
        },
        // 生成报表
        produceHandle(){
            this.produceVisible = true
            this.reportList = [
                {
                    StrSettleDate:'',//选择月份
                    StrBusitype:'',//业务分类
                    StrPricetype:''//金额分类
                }
            ]
        },
        saveProHandle(){
            let that = this
            if(this.isNull(this.StrActualDate)){
                this.$message({ type: 'warning', message: '请选择实发月份' })
                return false
            }
            if(that.reportList.some(val => this.isNull(val.StrSettleDate))){
                this.$message({ type: 'warning', message: '请选择月份' })
                return
            }
            if(that.reportList.some(val => this.isNull(val.StrBusitype))){
                this.$message({ type: 'warning', message: '请选择业务分类' })
                return
            }
            if(that.reportList.some(val => this.isNull(val.StrPricetype))){
                this.$message({ type: 'warning', message: '请选择金额分类' })
                return
            }
            // 判断是否有重复数据
            let arr = JSON.parse(JSON.stringify(that.reportList))
            for (let i = 0; i < arr.length; i++) {
                for(let j = i+1; j < arr.length; j++){
                    if((arr[i].StrSettleDate==arr[j].StrSettleDate)&&(arr[i].StrBusitype==arr[j].StrBusitype)&&(arr[i].StrPricetype==arr[j].StrPricetype)){
                        arr.splice(j,1);
                        j--;
                    }
                }
            }
            if(that.reportList.length!=arr.length){
                this.$message({ type: 'warning', message: '存在重复数据，请重新选择' })
                return
            }
            let eleLength = that.reportList.length
            let checkQuery = {
                StrSettleDate:that.reportList[eleLength-1].StrSettleDate,// 选择月份
                StrBusitype:that.reportList[eleLength-1].StrBusitype,// 选择业务分类
                StrPricetype:that.reportList[eleLength-1].StrPricetype// 选择金额分类
            }
            // 实发报表-判定最后一个组合是否已经使用
            xz.getIsUsedcloumname(checkQuery).then(res => {
                if (res.status != 'ok') {
                    // console.log('rr',res)
                    this.$message({ type: 'error', message: res.msg })
                    return false
                }else{
                    this.isSaveHandle = true
                    this.$confirm('已生成报表的月份不能再重新导入删除，是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        xz.saveConstrCost({StrActualDate:this.StrActualDate},this.reportList).then(res => {
                            if (res.status == 'ok') {
                                // console.log('rr',res)
                                this.produceVisible = false
                                this.listQuery.gdident = res.msg
                                this.titleQuery.gdident = res.msg
                                // 表头
                                this.getTableTitleLists()
                            }else{
                                this.$message({ type: 'error', message: res.msg })
                            }
                            this.isSaveHandle = false
                        })
                    }).catch(() => {
                        // this.produceVisible = false
                        this.isSaveHandle = false
                    })
                }
            })
            // console.log('gg',that.reportList,arr)
        },
        // 获取表头
        getTableTitleLists(){
          xz.getConstrCostHeard({gdident:this.titleQuery.gdident}).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
            // console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getCostRecordsLists(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                    this.tableData = res.msg
                    this.total = res.totalcount
                    if(!this.isNull(res.msg)){
                        for (let i = 0; i < res.msg.length; i++) {
                            let element = res.msg[i];
                            this.$set(element,'isEditInput',true)
                        }
                    }
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
            this.listQuery = this.$options.data.call(this).listQuery
            if(!this.isNull(this.$route.query.gdident)){
                this.listQuery.gdident = this.$route.query.gdident
                this.titleQuery.gdident = this.$route.query.gdident
            }else{
                this.listQuery.gdident = this.hisQuery.gdident
                this.titleQuery.gdident = this.hisQuery.gdident
            }
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        },
        isNullNotZero(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || (o+'') == '' || o == 'null' || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.dtl_box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.dtl_box p {
    width: 60px;
    font-size: 14px;
    color: #909399;
    margin-right: 4px;
}
.dtl_box div {
    font-size: 14px;
    color: #333;
}
.f_box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.f_left{
    width: 60px;
    text-align: right;
    margin-right: 4px;
}
.add_form_item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.add_form_item .s_input{
    margin-right: 6px;
    width: 220px;
    text-align: center;
}
.dlt_icon{
    display: inline-block;
    font-size: 18px;
    color:#999;
    margin-left:20px;
    cursor: pointer;
}
.add_title_box{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 10px;
}
.t_item{
    width: 220px;
    text-align: center;
}
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
</style>
<style>
.p_history_box .el-date-editor.el-input__inner{
    width: 260px!important;
}
.p_history_box .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    border-color: #fff;
    text-align: center;
}
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>